module.exports = __webpack_public_path__ + "static/bonzi-buddy-bd6aa554708c693eaf323db5a6c0962a.svg";